import { render } from "./Top-Doctors.vue?vue&type=template&id=19ae2e3c&scoped=true&ts=true"
import script from "./Top-Doctors.vue?vue&type=script&lang=ts"
export * from "./Top-Doctors.vue?vue&type=script&lang=ts"

import "./Top-Doctors.vue?vue&type=style&index=0&id=19ae2e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ae2e3c"]])

export default __exports__